<template>
  <div class="screen-booking">
    <div class="popup-aside-plain">
      <div class="popup-takeResa">
        <div style="text-align:center">{{ getAllInfos.restoName }}</div>
        <div style="font-weight:100; font-size:14px">
          <div style="text-align:center">{{ getAllInfos.restoAdresse }}</div>
          <div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
        </div>
      </div>
      <div class="success-container" v-loading="loading">
        <el-row :class="'black-inputs'">
          <el-col :span="18" :offset="3">
            Les informations CB sont validées.<br>
            <div>Vous allez être redirigé vers l'application automatiquement</div>
            <div>si ce n'est pas le cas cliquez <a :href="link">ici</a></div>
            <br>
            <div></div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// ------------------------------------------------------------------------------------ Imports
import { mapActions, mapGetters } from 'vuex';
import 'whatwg-fetch';
import { ERequestType, fetchGetHelper } from '../tools/fetch';
import { dateToTimeStamp } from './../tools/timeTool';

export default {
  name: 'SuccessApp',
  // -------------------------------------------------------------------------------- Datas
  data() {
    return {
      currentResa: undefined,
      currentClient: undefined,
      loading: true,
      inValidation: false,
      type: null,
      value: 0,
      link: '#'
    }
  },
  computed: {
    // ------------------------------------------------------------------------------ Getters
    ...mapGetters({
      getAllInfos: 'infos/getAllInfos',
      getUidPublic: 'newUsers/getUidPublic'
    }),
    getCurrentResa: function () {
      return this.currentResa
    }
  },
  methods: {
    // ----------------------------------------------------------------------------- Methods and Actions
    ...mapActions({
      checkClientByCidExisting: 'newClients/checkClientByCidExisting',
      findRealUserRole: 'newUsers/findRealUserRole',
      updatePayementInfoDone: 'newReservations/updatePayementInfoDone',
      loadInfos: 'infos/loadInfos'
    }),
    getLinkModify: function (resa) {
      let host = `http://${window.location.hostname}`
      let ts = dateToTimeStamp(resa.dateResa.day, resa.dateResa.month - 1, resa.dateResa.year)
      return `${host}/change/${this.getUidPublic.toString()}/${ts.toString()}/${resa.id.toString()}`
    },
    validResa: function () {
      if (!this.inValidation) {
        this.inValidation = true
        // get cash resa by id
        fetchGetHelper(ERequestType.CASHRESAS.GET_BY_ID, `crid=${this.$router.currentRoute.params.crid}`).then((res) => {
          this.type = res.data.type
          this.value = Math.round((parseFloat(res.data.amount) * parseInt(res.data.couverts)) * 100) / 100

          this.loading = false

          // redirection rules afetr 4 second
          setTimeout(() => {
            this.findRealUserRole().then((u) => {
              if (u === 'Permanence') {
                // for permanence
                this.$router.push({ name: 'PRedirect', params: { id: res.data.restoid } })
                window.location.reload()
              } else {
                // for resto
                this.$router.push({ name: 'Restaurant' })
              }
            })
          }, 4000)
        })
      }
    }
  },
  watch: {
    'getAllInfos': function (val, oldVal) {
      if (val.restoName) {
        this.validResa()
      }
    }
  },
  // ------------------------------------------------------------------------------------ Created
  created: function () {
    this.loadInfos().then(res => {
      console.log(res)
    })
    if (this.getAllInfos.restoName) {
      this.validResa()
    }
    // remove version
    if (this.$parent.$refs.version !== undefined) this.$parent.$refs.version.remove()
  }
}
</script>

<style lang="scss">
@use "../styles/vars";
@use "../styles/mixins";

@use "../styles/components/elements/popup";
@use "../styles/components/elements/blackInputs";
@use "../styles/components/elements/buttons";
@use "../styles/components/elements/nav";
@use "../styles/components/elements/notif";
@use "../styles/components/elements/selector";
@use "../styles/components/layout/screens";
@use "../styles/components/layout/calendar";

a {
  color: var(--color_blue_azure);
}

.success {
  &-content {
    text-align: center;
    font-weight: 100;
    margin-top: 1rem;
  }

  &-container {
    padding-bottom: 1rem;
  }

  &-btns {
    margin-top: 2rem;
  }

  &-infos {
    margin-top: 1rem;
    font-weight: bold;
  }
}
</style>
